import repository from './repsitory'

const resource = '/user'
const token = 'token'
export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    token (credentials) {
        return repository.post(`${token}`, credentials)
    },
    addUser (data) {
        return repository.post(`${resource}`, data)
    },
    updateUser (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    getUsersWithOutPerson (userId) {
        return repository.get(`${resource}/WithOutPerson/${userId}`)
    },
    getRoles () {
        return repository.get(`${resource}/roles`)
    },
}
